import React, { useState, useContext, useEffect } from 'react'
import { DatePicker, Table, Button, Input, Modal, Icon, message } from 'antd'
import { getTpsFileLog, getTpsFileLogBlob } from 'api/pgads'
import { connect } from 'react-redux'
import moment from 'moment'
import { getApiTargetInfo } from 'core'
import { ErrorContext, SpinContext } from 'context'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
const Column = getBlobTask => [
  {
    title: 'Trans ID',
    dataIndex: 'transId',
    width: 200,
  },
  {
    title: 'Service Name',
    dataIndex: 'serviceName',
    width: 250,
  },
  {
    title: 'Company',
    dataIndex: 'company',
    width: 80,
  },
  {
    title: 'Transaction Date',
    dataIndex: 'transDate',
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY'),
  },

  {
    title: 'Request',
    dataIndex: 'requestBlob',
    width: 100,
    render: text => (
      <span>
        <Icon
          style={{ marginRight: `5px`, cursor: `pointer` }}
          theme="twoTone"
          type={
            text !== undefined && text.startsWith('1:') ? 'file-text' : 'file'
          }
          onClick={() =>
            text !== undefined && text.startsWith('1:')
              ? getBlobTask(text.substring(2), 'request')
              : ''
          }
          key="request_blob"
        />
        {text !== undefined && text.startsWith('1:') ? 'BLOB' : 'N/A'}
      </span>
    ),
  },
  {
    title: 'Response',
    dataIndex: 'responseBlob',
    width: 100,
    render: text => (
      <span>
        <Icon
          style={{ marginRight: `5px`, cursor: `pointer` }}
          theme="twoTone"
          type={
            text !== undefined && text.startsWith('1:') ? 'file-text' : 'file'
          }
          onClick={() =>
            text !== undefined && text.startsWith('1:')
              ? getBlobTask(text.substring(2), 'response')
              : ''
          }
          key="responseBlob"
        />
        {text !== undefined && text.startsWith('1:') ? 'BLOB' : 'N/A'}
      </span>
    ),
  },

  {
    title: 'Modifier',
    dataIndex: ['modificationInfo', 'user'],
    width: 150,
  },
  {
    title: 'Modified Date',
    dataIndex: ['modificationInfo', 'modDate'],
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  },
  // modifierCol,
  // modifiedDateCol,
  {
    title: 'Request Params',
    dataIndex: 'requestParams',
    width: 500,
    // fixed: 'right',
    //  render: (text) => {
    //   return <div style={{maxWidth: 200, overflowX: 'auto'}}>
    //     {text}
    //   </div>
    // }
  },
  {
    title: 'Exception',
    dataIndex: 'exception',
    width: 1000,
    // render: text => text ? text.substring(0,200)+"..." : ""
    ellipsis: true,
  },
]

const TpsFileLog = props => {
  const targetInfo = props.targetInfo
  const [data, setData] = useState(null)
  const [selectedDate, setSelectedDate] = useState(moment())

  useEffect(_ => setData([]), [selectedDate, setSelectedDate])
  const [modal, setModal] = useState(false)
  const [blob, setBlob] = useState(null)

  const [filter, setFilter] = useState('')
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const retrieveTask = ({ date = selectedDate }) => {
    setSpinning(true)

    getTpsFileLog(targetInfo)(date).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }

  const getBlobTask = (transId, type) => {
    setSpinning(true)
    getTpsFileLogBlob(targetInfo)({ transId, type }).fork(setError, res => {
      setSpinning(false)
      setModal(true)
      setBlob(res)
    })
  }

  const filteredData = (data, filterText) => {
    return (
      data &&
      data.filter(d => {
        if (filterText.trim().length <= 0) return true
        return (
          (d.serviceName &&
            d.serviceName.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.transId &&
            d.transId.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.transDate &&
            moment(d.transDate)
              .format('MM/DD/YYYY HH:mm:ss')
              .toLowerCase()
              .includes(filterText.toLowerCase()))
        )
        // (d.serviceName && d.serviceName.startsWith(filterText)) ||
        // (d.transId && d.transId.includes(filterText))
      })
    )
  }
  //   const confirm = _ => {
  //     deletWebserviceLog(targetInfo).fork(setError, _ => {
  //       setSpinning(false)
  //       message.info('Log Deleted.')
  //     })
  //   }

  return (
    <div>
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          MISO File Logs
        </Title>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />
        <Button
          style={{ marginLeft: '10px' }}
          type="primary"
          onClick={_ => retrieveTask({})}
        >
          Retrieve
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          style={{ marginLeft: '10px', width: 200 }}
          onChange={e => setFilter(e.target.value)}
        />
        {/* <Popconfirm
          title={
            <div>
              <div>Are you sure delete this task?</div>
              <div>
                This will delete log which has Transaction Date lower than 5
                months ago.
              </div>
            </div>
          }
          onConfirm={confirm}
          // onCancel={cancel}
          okText="Confirm"
          cancelText="Cancel"
        >
          <Button type="danger" style={{ marginLeft: 20 }}>
            Delete LOG
          </Button>
        </Popconfirm> */}
        <Modal
          maskClosable
          title="File"
          visible={modal}
          onOk={() => setModal(false)}
          onCancel={() => setModal(false)}
          destroyOnClose
          closable
          footer={
            <div>
              {window.navigator.clipboard && (
                <Button
                  icon="copy"
                  theme="twoTone"
                  type="dashed"
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                  onClick={() => {
                    window.navigator.clipboard
                      .writeText(blob)
                      .then(() => {
                        message.info('Data Copied.')
                      })
                      .catch(e => console.log(e))
                      .finally(_ => setModal(false))
                  }}
                >
                  Copy & Close
                </Button>
              )}
              <Button type="primary" onClick={() => setModal(false)}>
                Close
              </Button>
            </div>
          }
        >
          <div
            style={{
              maxHeight: '400px',
              display: 'grid',
              gridTemplateColumns: '1fr',
              overflowX: 'auto',
            }}
          >
            <Input.TextArea autosize value={blob} />
          </div>
        </Modal>
      </CriteriaRow>
      <FullHeightSizer heightOffset={220}>
        {({ height }) => (
          <Content style={{ height: height + 10, padding: '10px' }}>
            <Table
              className="tableifw"
              style={{ height: height - 50 }}
              columns={Column(getBlobTask)}
              dataSource={filteredData(data, filter)}
              bordered
              pagination={false}
              scroll={{ y: height - 50, x: true }}
              // scroll={{ y: true, x: true}}
              size="small"
              rowKey={e => e.transId}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(TpsFileLog)
